/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PolicyFundDto } from '../../models/policy-fund-dto';

export interface PolicyFundControllerFindPublished$Params {
  referenceDate?: string;
}

export function policyFundControllerFindPublished(http: HttpClient, rootUrl: string, params?: PolicyFundControllerFindPublished$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PolicyFundDto>>> {
  const rb = new RequestBuilder(rootUrl, policyFundControllerFindPublished.PATH, 'get');
  if (params) {
    rb.query('referenceDate', params.referenceDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PolicyFundDto>>;
    })
  );
}

policyFundControllerFindPublished.PATH = '/api/financial-support/policy-funds';
